'use client';

import { skipToken, useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../contexts/ApiContext';
import { queryKeys } from '../../../lib/queryClient';
import type { RecentReceiver, RecentReceiversResponse } from '../../../services/generated/Api';

export type { RecentReceiver, RecentReceiversResponse as AchievementRecentReceiversResponse };

export function useAchievementRecentReceivers(key?: string) {
  const api = useApiClient();
  return useQuery<RecentReceiversResponse>({
    queryKey: queryKeys.achievementsRecentReceivers(key),
    queryFn: key ? () => api.api.achievementsControllerGetRecentReceivers(key) : skipToken,
    staleTime: 5 * 60 * 1000,
  });
}
